import * as yup from 'yup';

yup.addMethod(yup.string, 'select', function (nameField) {
  return this.test('select', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(nameField)[0];
    return new Promise((resolve, reject) => {
      if ((field && field.value) || typeof field === 'undefined') {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  company: yup.string().select('company'),
  description: yup
    .string()
    .required()
    .trim()
});

export default schema;
